/**
 * Get each component of the address from the place details,
 * and then fill-in the corresponding field on the form.
 * place.address_components are google.maps.GeocoderAddressComponent objects
 * which are documented at http://goo.gle/3l5i5Mr
 * @param {*} location
 * @returns readable address object
 */
export function fillInAddress(location) {
  const place = location.getPlace();

  let address1 = "",
    postcode = "",
    locality = "",
    apartment = "",
    sublocality = "",
    state = "",
    country = "",
    countryShort = "",
    stateAlpha = "";

  for (const component of place.address_components) {
    const componentType = component.types[0];
    switch (componentType) {
      case "subpremise": {
        apartment = `${component.long_name}`;
        break;
      }
      case "street_number": {
        address1 += `${component.long_name} `;
        break;
      }
      case "route": {
        address1 += component.short_name;
        break;
      }
      case "postal_code": {
        postcode = `${component.long_name}${postcode}`;
        break;
      }
      case "postal_code_suffix": {
        postcode = `${postcode}-${component.long_name}`;
        break;
      }
      case "locality":
        locality = component.long_name;
        break;
      case "administrative_area_level_1": {
        stateAlpha = component.short_name;
        state = component.long_name;
        break;
      }
      case "sublocality_level_1":
        address1 += `, ${component.long_name}`;
        break;
      case "sublocality_level_2":
        address1 = `${component.long_name} ${address1}`;
        break;
      case "sublocality":
        sublocality = component.long_name;
        break;
      case "country":
        country = component.long_name;
        countryShort = component.short_name;
        break;
    }
  }

  return {
    address: address1,
    postal: postcode,
    locality,
    apartment,
    state,
    country,
    countryAlpha: countryShort,
    stateAlpha,
    sublocality,
  };
}
